/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Draft_Lines_RequiredInputs */

const vi_einvoice_draft_lines_required = /** @type {(inputs: Einvoice_Draft_Lines_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hóa đơn phải còn ít nhất 1 dòng hàng. Vui lòng bấm Hoàn tác ở một dòng đã xóa.`)
};

/**

* @param {Einvoice_Draft_Lines_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_draft_lines_required = /** @type {((inputs?: Einvoice_Draft_Lines_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Draft_Lines_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_draft_lines_required(inputs)
});